module.exports = __webpack_public_path__ + "img/Mickie-Javaid-Camua-fortified-city.3c056695.jpg";